import styles from './SavingsSlider.module.scss';

import React from 'react';
import Slider from 'react-rangeslider';

class SavingsSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 6
    };
  }

  handleChange = (value) => {
    this.setState({
      value: value
    });
  };

  render() {
    return (
      <div className={this.props.className} styleName='savings-slider'>
          <div styleName='estimated-savings'>
              {estSavingsFmt(this.state.value)}
          </div>
          <div styleName='label'>Estimated savings</div>
          <div styleName='slider'>
              <Slider
                  min={5}
                  max={8}
                  step={0.05}
                  labels={{5: '$100k', 6: '$1MM', 7: '$10MM', 8: '$100MM+'}}
                  format={annualSpendFmt}
                  value={this.state.value}
                  onChange={this.handleChange}
              />
          </div>
          <div styleName='label'>Your annual shipping spend</div>
      </div>
    );
  }
}

/**
 * Converts the given power-of-10 to a dollar savings value.
 */
const annualSpendFmt = (pow) => {
  const val = Math.pow(10, pow);

  // Now round the value to the nearest 10^(pow - 1).
  const roundPlaces = Math.pow(10, Math.floor(pow) - 1);
  const roundedVal = Math.round(Math.ceil(val / roundPlaces) * roundPlaces);

  // Finally, convert the rounded value to a dollar string.
  return dollarStrFmt(roundedVal);
};

/**
 * Converts the given power-of-10 to a dollar savings value.
 *
 * Assumes a fixed 4% savings rate.
 */
const estSavingsFmt = (pow) => {
  return dollarStrFmt(Math.round((Math.pow(10, pow) * 0.04)));
};

const dollarStrFmt = (val) => {
  return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export default SavingsSlider;



// WEBPACK FOOTER //
// ./src/components/SavingsSlider.js